module.exports = __webpack_public_path__ + "img/ddgl@2x.d25cac77.png";